import { produce as applyImmutably } from 'immer';
import { handleActions } from 'redux-actions';
import { actions } from '../../actions/email';
export const { emailListAll, emailListAllSucceeded, emailListAllFailed, emailAdd, emailAddSucceeded, emailAddFailed, emailGet, emailGetSucceeded, emailGetFailed, emailDelete, emailDeleteSucceeded, emailDeleteFailed, emailUpdate, emailUpdateSucceeded, emailUpdateFailed, emailGetFlows, emailGetFlowsSucceeded, emailGetFlowsFailed, } = actions;
const DEFAULT_EMAIL_SIGNATURE = `<p>
  Best regards,
</p>
<p>
  {{agent_fullname}}<br />
  {{organization_name}}
</p>`;
function emptyEmail() {
    return {
        organization_id: null,
        email_address: null,
        sender_name: null,
        spf_domain: null,
        spf_sender_email: null,
        signature_template: DEFAULT_EMAIL_SIGNATURE,
    };
}
const initialState = {
    emailList: [],
    meta: {
        asyncStatus: 'succeeded',
        getFlows: 'succeeded',
        hasChanged: false,
        slug: '',
    },
    currentEmail: emptyEmail(),
    ui: {
        isEditModalOpen: false,
        isConfirmModalOpen: false,
    },
    flows: [],
};
// Reducer
export const email = handleActions({
    [emailListAll.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'loading' }) });
    },
    [emailListAllSucceeded.toString()]: (state, action) => {
        const emailList = action.payload.data.slice();
        let currentEmail = Object.assign({}, state.currentEmail);
        const foundEmail = emailList.find((e) => state.currentEmail.email_address === e.email_address);
        if (foundEmail !== undefined) {
            currentEmail = foundEmail;
        }
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'succeeded' }), emailList: emailList, currentEmail: currentEmail });
    },
    [emailListAllFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'failed' }) });
    },
    [emailAdd.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'loading' }) });
    },
    [emailAddSucceeded.toString()]: (state, action) => {
        const removeUnwantedEmails = (email) => email.email_address !== action.payload.data.email_address;
        return applyImmutably(state, (draftState) => {
            draftState.meta.asyncStatus = 'succeeded';
            draftState.ui.isEditModalOpen = false;
            draftState.emailList = [
                action.payload.data,
                ...state.emailList.filter(removeUnwantedEmails),
            ];
        });
    },
    [emailAddFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'failed' }) });
    },
    [emailGet.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'loading' }) });
    },
    [emailGetSucceeded.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'succeeded' }) });
    },
    [emailGetFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'failed' }) });
    },
    [emailDelete.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'loading' }) });
    },
    [emailDeleteSucceeded.toString()]: (state, action) => {
        const emaillistCopy = state.emailList.slice();
        const emailList = emaillistCopy.filter((x) => x.email_address !== action.payload.data.email_address);
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'succeeded' }), ui: Object.assign(Object.assign({}, state.ui), { isConfirmModalOpen: false }), currentEmail: emptyEmail(), emailList: emailList });
    },
    [emailDeleteFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'failed' }) });
    },
    [emailGetFlows.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { getFlows: 'loading' }) });
    },
    [emailGetFlowsSucceeded.toString()]: (state, action) => {
        const flows = action.payload.data &&
            action.payload.data.conversation_flows &&
            Array.isArray(action.payload.data.conversation_flows) === true
            ? action.payload.data.conversation_flows
            : [];
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { getFlows: 'succeeded' }), flows: flows });
    },
    [emailGetFlowsFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { getFlows: 'failed' }) });
    },
    [emailUpdate.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'loading' }) });
    },
    [emailUpdateSucceeded.toString()]: (state, action) => {
        const index = state.emailList.findIndex((email) => {
            console.info(email, action.payload.data.email_address);
            return email.email_address === action.payload.data.email_address;
        });
        if (index > -1) {
            const emailList = state.emailList.slice();
            const email = Object.assign({}, state.emailList[index]);
            if (email !== undefined) {
                emailList[index] = Object.assign({}, action.payload.data);
                return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'succeeded' }), ui: Object.assign(Object.assign({}, state.ui), { isEditModalOpen: false }), emailList: emailList });
            }
            return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'succeeded' }), ui: Object.assign(Object.assign({}, state.ui), { isEditModalOpen: false }) });
        }
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'succeeded' }), ui: Object.assign(Object.assign({}, state.ui), { isEditModalOpen: false }) });
    },
    [emailUpdateFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'failed' }) });
    },
}, initialState);
